import trads from '~/intl/trads.json'

export const simulatorData = ({ lang }) => {
  console.log(lang)

  return {
    section1Block3VehicleCategories: {
      VL: {
        lib: trads[lang].comparator.vehicleCategories.lightVehicles,
        icon: 'voiture',
        subLib: '',
        consumptionRatio: 1,
      },
      VUL: {
        lib: trads[lang].comparator.vehicleCategories.lightUtilityVehicles,
        icon: 'camionette',
        subLib: '',
        consumptionRatio: 2,
      },
      CAR: {
        lib: trads[lang].comparator.vehicleCategories.buses,
        icon: 'bus',
        subLib: '',
        consumptionRatio: 6,
      },
      PL: {
        lib: trads[lang].comparator.vehicleCategories.dustcartsAnd,
        icon: 'benne',
        subLib: '',
        consumptionRatio: 7.5,
      },
    },
    fuelDataGlobalConfiguration: {
      H2: {
        lib: trads[lang].comparator.fuelDataGlobalConfiguration.hydrogen,
        mwh: 25.37713,
        cout: {
          color: 'red',
          barCount: 5,
        },
        csvl: 1.1,
        unit: '€/kg',
        aides: {
          color: 'green',
          barCount: 5,
        },
        facilite: {
          color: 'blue',
          barCount: 2,
        },
        taxation: {
          color: 'green',
          barCount: 1,
        },
        emissions: {
          color: 'green',
          barCount: 1,
        },
        utilisation: {
          color: 'blue',
          barCount: 4,
        },
        generalColor: 'green',
        modeTransport: [
          'transpalette',
          'voiture',
          'camionette',
          'camion',
          'superCamion',
          'bus',
          'train',
        ],
      },
      BIO: {
        lib: trads[lang].comparator.fuelDataGlobalConfiguration.biongv,
        cout: {
          color: 'blue',
          barCount: 2,
        },
        csvl: 5,
        unit: '€/kg',
        aides: {
          color: 'blue',
          barCount: 3,
        },
        facilite: {
          color: 'blue',
          barCount: 4,
        },
        taxation: {
          color: 'blue',
          barCount: 3,
        },
        emissions: {
          color: 'green',
          barCount: 1,
        },
        utilisation: {
          color: 'green',
          barCount: 1,
        },
        generalColor: 'green',
        modeTransport: [
          'transpalette',
          'voiture',
          'camionette',
          'camion',
          'superCamion',
          'bus',
          'train',
        ],
      },
      ELEC: {
        lib: trads[lang].comparator.fuelDataGlobalConfiguration.electricity,
        cout: {
          color: 'blue',
          barCount: 4,
        },
        csvl: 17,
        unit: '€/kWh',
        aides: {
          color: 'green',
          barCount: 5,
        },
        facilite: {
          color: 'red',
          barCount: 1,
        },
        taxation: {
          color: 'green',
          barCount: 1,
        },
        emissions: {
          color: 'green',
          barCount: 1,
        },
        utilisation: {
          color: 'red',
          barCount: 5,
        },
        generalColor: 'green',
        modeTransport: ['transpalette', 'voiture', 'camionette', 'train'],
      },
      B7: {
        lib: trads[lang].comparator.fuelDataGlobalConfiguration.diesel,
        mwh: 95.2381,
        cout: {
          color: 'blue',
          barCount: 2,
        },
        csvl: 5.5,
        unit: '€/l',
        aides: {
          color: 'red',
          barCount: 1,
        },
        facilite: {
          color: 'green',
          barCount: 5,
        },
        taxation: {
          color: 'red',
          barCount: 5,
        },
        emissions: {
          color: 'red',
          barCount: 5,
        },
        utilisation: {
          color: 'blue',
          barCount: 3,
        },
        generalColor: 'other',
        modeTransport: [
          'voiture',
          'camionette',
          'camion',
          'superCamion',
          'bus',
        ],
      },
      E85: {
        lib: trads[lang].comparator.fuelDataGlobalConfiguration.super,
        mwh: 153.84615,
        cout: {
          color: 'green',
          barCount: 1,
        },
        csvl: 8.5,
        unit: '€/l',
        aides: {
          color: 'blue',
          barCount: 3,
        },
        facilite: {
          color: 'green',
          barCount: 5,
        },
        taxation: {
          color: 'blue',
          barCount: 2,
        },
        emissions: {
          color: 'blue',
          barCount: 3,
        },
        utilisation: {
          color: 'blue',
          barCount: 3,
        },
        generalColor: 'other',
        modeTransport: ['voiture'],
      },
      GNL: {
        lib: trads[lang].comparator.fuelDataGlobalConfiguration.lng,
        cout: {
          color: 'blue',
          barCount: 3,
        },
        csvl: 5,
        unit: '€/kg',
        aides: {
          color: 'blue',
          barCount: 2,
        },
        facilite: {
          color: 'blue',
          barCount: 3,
        },
        taxation: {
          color: 'blue',
          barCount: 3,
        },
        emissions: {
          color: 'blue',
          barCount: 4,
        },
        utilisation: {
          color: 'blue',
          barCount: 3,
        },
        generalColor: 'other',
        modeTransport: ['superCamion', 'bateau'],
      },
      GNV: {
        lib: trads[lang].comparator.fuelDataGlobalConfiguration.ngv,
        cout: {
          color: 'blue',
          barCount: 2,
        },
        csvl: 5,
        unit: '€/kg',
        aides: {
          color: 'green',
          barCount: 2,
        },
        facilite: {
          color: 'blue',
          barCount: 3,
        },
        taxation: {
          color: 'blue',
          barCount: 3,
        },
        emissions: {
          color: 'blue',
          barCount: 3,
        },
        utilisation: {
          color: 'blue',
          barCount: 2,
        },
        generalColor: 'other',
        modeTransport: [
          'transpalette',
          'voiture',
          'camionette',
          'camion',
          'superCamion',
          'bus',
          'train',
        ],
      },
      GPL: {
        lib: trads[lang].comparator.fuelDataGlobalConfiguration.lpg,
        cout: {
          color: 'green',
          barCount: 1,
        },
        csvl: 8.2,
        unit: '€/l',
        aides: {
          color: 'blue',
          barCount: 3,
        },
        facilite: {
          color: 'green',
          barCount: 5,
        },
        taxation: {
          color: 'blue',
          barCount: 2,
        },
        emissions: {
          color: 'blue',
          barCount: 4,
        },
        utilisation: {
          color: 'blue',
          barCount: 3,
        },
        generalColor: 'other',
        modeTransport: ['transpalette', 'voiture', 'camionette'],
      },
      SPE10: {
        lib: trads[lang].comparator.fuelDataGlobalConfiguration.sp95,
        mwh: 105.26316,
        cout: {
          color: 'blue',
          barCount: 2,
        },
        csvl: 6.8,
        unit: '€/l',
        aides: {
          color: 'red',
          barCount: 1,
        },
        facilite: {
          color: 'green',
          barCount: 5,
        },
        taxation: {
          color: 'red',
          barCount: 5,
        },
        emissions: {
          color: 'red',
          barCount: 4,
        },
        utilisation: {
          color: 'blue',
          barCount: 3,
        },
        generalColor: 'other',
        modeTransport: ['voiture'],
      },
    },
  }
}
